var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"one-cms-html-box",domProps:{"innerHTML":_vm._s((_vm.htmlBox && _vm.htmlBox.content) || _vm.html)}})
}
var staticRenderFns = []

export { render, staticRenderFns }